import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@deno+kv@0.12.0_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@9.28._wheeikyoin4imv5q2gbo7v5awe/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}